import "./index.less"
import { forwardRef, useEffect, useImperativeHandle, useState } from "react"
import { graphicStore } from "@/global/store/graphic-store"
import { ModelBase } from "pytha";
import { getSensors } from "@/api/device/sensor";
import { useParams } from "react-router-dom";
import { SENSOR_TYPE } from "@/enums/sensor-type";
import { Sensor } from "@/global/interface/device/sensor";
import MonitorRightMainPanel from "./monitor";
import AnemoclinographRightMainPanel from "./anemoclinograph";
import FluviographRightMainPanel from "./fluviograph";
import { createSpriteCanvas } from "@/global/utils/sprite-utils";
import { CanvasTexture } from "three";
import MonitorObjectRightMainPanel from "./monitor-object";
import { ReactComponent as WarningSvg } from "./icons/warning.svg"
import WarningRightMainPanel from "./warning";
import { emitter } from "@/global/listeners";
import { Emit_Event } from "@/enums/emit-event";
import DeviceListPanel from "./device";

const ShowBtnIndex = {
    SHOW_NONE: 0,
    SHOW_DEVICE: 1,
    SHOW_MONITOR: 2
}

interface IProps {
    finishInit: boolean,
    showPriceType: number
    showDevice: boolean
    onChangeShowDevice: (show: boolean) => void
}

export default function DisplayRightPanel(props: IProps) {

    const { projectId } = useParams()
    const [selectEntity, setSelectEntity] = useState<ModelBase>(null)
    const [oldSelectUuid, setOldSelectUuid] = useState<string>()
    const [showWarning, setShowWarning] = useState<boolean>(false);

    useEffect(() => {
        emitter.on(Emit_Event.WARNING_PANEL, onWarningClick)
        return (() => {
            emitter.off(Emit_Event.WARNING_PANEL, onWarningClick)
        })
    }, [showWarning])

    useEffect(() => {
        if (graphicStore?.extraContext?.getCurrentViewEditor()) {
            graphicStore?.extraContext?.getCurrentViewEditor().listeners.signals.windowResize.dispatch();
        } else {
            return
        }

        if (!selectEntity) return
        // console.log("选中图元：" + selectEntity.uuid)
        // // 设置为选中广告牌
        // let spriteItem = graphicStore?.spriteMap[selectEntity?.uuid]
        // 将旧的取消选中
        if (oldSelectUuid?.length > 0) {
            let oldSpriteItem = graphicStore?.spriteMap[oldSelectUuid]
            if (oldSpriteItem) {
                oldSpriteItem.isSelect = false
                if (oldSpriteItem.isMonitor) {
                    let oldSprite = oldSpriteItem.sprite
                    if (oldSprite?.parent) {
                        oldSprite.parent.remove(oldSprite)
                    }
                } else {
                    let oldCanvas = createSpriteCanvas(oldSpriteItem.text, false)
                    let oldSprite = oldSpriteItem.sprite
                    oldSprite.material.map = new CanvasTexture(oldCanvas)
                    oldSprite.material.map.needsUpdate = true
                    if (props.showPriceType != ShowBtnIndex.SHOW_DEVICE) {
                        if (oldSprite.parent) {
                            oldSprite.parent.remove(oldSprite)
                        }
                    }
                }
            }
        }
        let spriteItem = graphicStore?.spriteMap[selectEntity?.uuid]
        if (spriteItem) {
            spriteItem.isSelect = true
            if (spriteItem?.isMonitor) {
                graphicStore.extraContext?.sceneContext?.scene?.add(spriteItem.sprite)
            } else {
                let newCanvas = createSpriteCanvas(spriteItem.text, true)
                let sprite = spriteItem.sprite
                sprite.material.map = new CanvasTexture(newCanvas)
                sprite.material.map.needsUpdate = true
                if (props.showPriceType != ShowBtnIndex.SHOW_DEVICE) {
                    graphicStore?.extraContext?.sceneContext.scene.add(sprite)
                }
            }
        }

        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.needRender.dispatch('redraw');
        setOldSelectUuid(selectEntity?.uuid)
    }, [selectEntity])

    useEffect(() => {
        initData()
    }, [props.finishInit])

    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return () => { }

        graphicStore.extraContext.getCurrentViewEditor().listeners.signals.onSelectChanged.add(onSelectChange)
        return (() => {
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners?.signals.onSelectChanged.remove(onSelectChange)
        })
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    const initData = () => {
        if (graphicStore?.extraContext?.getCurrentViewEditor()) {
            getSensors(Number(projectId), { type: SENSOR_TYPE.CAMERA }).then(res => {
                let cameraList: Sensor[] = res.data || []

                if (!(cameraList.length > 0)) return
                let cameraEntityUuid = cameraList[0].primitiveUuid
                let cameraEntity = graphicStore?.extraContext?.getCurrentViewEditor().entityDict[cameraEntityUuid]
                if (cameraEntity) {
                    setSelectEntity(cameraEntity)
                }
            })
        }
    }

    const onSelectChange = (entities: ModelBase[]) => {
        if (entities?.filter(item => item.isSelected)?.length == 1) {
            setSelectEntity(entities?.filter(item => item.isSelected)[0])
            return
        } else {
            setSelectEntity(null)
        }
    }

    const onWarningClick = () => {
        setShowWarning(pre => !pre)
    }

    return (
        <div className="right-panel-main" style={{
            display: (selectEntity?.type === "AnemoclinographT"
                || selectEntity?.type === "MonitorT"
                || selectEntity?.type === "FluviographT"
                || selectEntity?.extraData?.monitorObjectId != null
                || showWarning || props.showDevice) ? 'flex' : 'none'
        }}>
            {/* 风速风向仪 */}
            {!props.showDevice && !showWarning && selectEntity?.type == "AnemoclinographT" && <AnemoclinographRightMainPanel entity={selectEntity} />}
            {/* 摄像头 */}
            {!props.showDevice && !showWarning && selectEntity?.type == "MonitorT" && <MonitorRightMainPanel entityUuid={selectEntity?.uuid} />}
            {/* 水位计 */}
            {!props.showDevice && !showWarning && selectEntity?.type == "FluviographT" && <FluviographRightMainPanel primitiveUuid={selectEntity?.uuid} />}
            {/* 监测对象 */}
            {!props.showDevice && !showWarning && selectEntity && selectEntity?.extraData?.monitorObjectId != null && <MonitorObjectRightMainPanel monitorObjectId={selectEntity?.extraData?.monitorObjectId} />}
            {/* 报警信息 */}
            {!props.showDevice && showWarning && <WarningRightMainPanel setShowWarning={setShowWarning} />}
            {props.showDevice && <DeviceListPanel onChangeShowDevice={props.onChangeShowDevice} />}
        </div >
    )
}